import React, { useEffect, useRef } from 'react';
import moment from 'moment';
import { useFormik } from 'formik';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { selectedTimeZoneTemplate, statusOptions, timeZoneOptionTemplate, timeZonesOptions } from '../../../utils/mics';
import { useDispatch, useSelector } from 'react-redux';
import appActions from '../../../appActions';

const SysStroreFilterForm = (props) => {
    
    const { handleSearch, handleReset, onFormValuesChange } = props;

    const dispatch = useDispatch();
    const filters = useSelector((state) => state.sysStore.filters);

    const countriesList = useSelector((state) => state.sysStore.countriesList);

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            storeId: filters?.storeId || '',
            vStoreId: filters?.vStoreId || '',
            title: filters?.title || '',
            groupId: filters?.groupId || '',
            region: filters?.region || '',
            country: filters?.country || '',
            city: filters?.city || '',
            timezone: filters?.timezone || '',
            status: filters?.status || null,
            date_from: filters?.date_from || '',
            date_till: filters?.date_till || '',
        },
        onSubmit: (values) => {
            const data = {
                ...values,
                date_from: values.date_from  ? moment(values.date_from).format('YYYY-MM-DD') : '',
                date_till: values.date_till ? moment(values.date_till).format('YYYY-MM-DD') : '',
            };
            dispatch(appActions.SYSSTORE_SET_FILTERS_REQUEST(values));
            handleSearch(data);
        },
    });

    const handleClear = () => {
        
        dispatch(appActions.SYSSTORE_SET_FILTERS_REQUEST({}));
        formik.resetForm();
        onFormValuesChange(null);
        handleReset();
    };

    const handleChange = (e) => {
        formik.handleChange(e);
        if (onFormValuesChange) {
            const values = { ...formik.values, [e.target.name]: e.target.value };
             const data = {
                ...values,
                date_from: values.date_from  ? moment(values.date_from).format('YYYY-MM-DD') : '',
                date_till: values.date_till ? moment(values.date_till).format('YYYY-MM-DD') : '',
            };
            onFormValuesChange(data);
        }
    }

    const isDateTillUpdated = useRef(false); // Track if update is needed

    useEffect(() => {
        if (
            formik.values.date_from &&
            (!formik.values.date_till || new Date(formik.values.date_till) < new Date(formik.values.date_from))
        ) {
            if (!isDateTillUpdated.current) { // Prevent infinite loop
                formik.setFieldValue("date_till", formik.values.date_from);
                isDateTillUpdated.current = true; // Mark as updated
            }
        } else {
            isDateTillUpdated.current = false; // Reset when update is not needed
        }
    }, [formik, formik.values.date_from]); // Only trigger when date_from changes
        
    const renderFormArea = () => {
        return (
            <>
                <div className="p-fluid formgrid grid w-full">
                    <div className="field col-12 md:col-3">
                        <label htmlFor="vStoreId">Store ID</label>
                        <InputText id="vStoreId" name="vStoreId" type="number" value={formik.values.vStoreId} onChange={handleChange} />
                    </div>
                    <div className="field col-12 md:col-3">
                        <label htmlFor="storeId">Store Code</label>
                        <InputText id="storeId" name="storeId" type="number" value={formik.values.storeId} onChange={handleChange} />
                    </div>
                    <div className="field col-12 md:col-3">
                        <label htmlFor="title">Title</label>
                        <InputText id="title" name="title" type="text" value={formik.values.title}  onChange={handleChange} />
                    </div>
                    <div className="field col-12 md:col-3">
                        <label htmlFor="groupId">Group ID</label>
                        <InputText id="groupId" name="groupId" type="text" value={formik.values.groupId} onChange={handleChange} />
                    </div>
                  
                    <div className="field col-12 md:col-3">
                        <label htmlFor="country">Country</label>
                        <Dropdown filter value={formik.values.country}
                            onChange={(e) => formik.setFieldValue('country', e.value)}
                            options={countriesList}
                            optionLabel="name"
                            optionValue="code"
                            placeholder="Select a country"
                            valueTemplate={selectedTimeZoneTemplate}
                            itemTemplate={timeZoneOptionTemplate} 
                            id='country'
                            name='country'
                        />
                    </div>
                    <div className="field col-12 md:col-3">
                        <label htmlFor="timezone">Timezone</label>
                        <Dropdown filter value={formik.values.timezone}
                            onChange={(e) => formik.setFieldValue('timezone', e.value)}
                            options={timeZonesOptions}
                            optionLabel="name"
                            optionValue="name"
                            placeholder="Select a timezone"
                            valueTemplate={selectedTimeZoneTemplate}
                            itemTemplate={timeZoneOptionTemplate} 
                            id='timezone'
                            name='timezone'
                        />
                    </div>
                    {/* <div className="field col-12 md:col-3">
                        <label htmlFor="location">Location</label>
                        <InputText id="location" name="location" type="text" value={formik.values.location} onChange={handleChange} />
                    </div> */}
                    <div className="field col-12 md:col-3">
                        <label htmlFor="status">Status</label>
                        <Dropdown filter showClear value={formik.values.status} onChange={handleChange} options={statusOptions}  id="status" name="status" optionLabel="name" optionValue='name' placeholder="Select status" />
                    </div>
                    
                    <div className="field col-12 md:col-3">
                        <label htmlFor="date_from">Date From</label>
                        <Calendar id="date_from" name="date_from" value={formik.values.date_from} onChange={handleChange} dateFormat="dd-mm-yy" showIcon maxDate={new Date()}/>
                    </div>
                    <div className="field col-12 md:col-3">
                        <label htmlFor="date_from">Date Till</label>
                        <Calendar id="date_till" name="date_till" value={formik.values.date_till} onChange={handleChange} dateFormat="dd-mm-yy" showIcon minDate={formik.values.date_from}/>
                    </div>
                </div>
                <div className="grid px-2 py-4 flex-row-reverse gap-10">
                    <Button type="submit" icon="pi pi-search" label="Search" severity="success" outlined className="p-button-success mr-2 tp" data-pr-tooltip="Search" />
                    <Button type="button" icon="pi pi-filter-slash" className='tp' data-pr-tooltip="Reset Filter" label="Reset Filter" severity="secondary" outlined  onClick={handleClear} />
                </div>
            </>
        );
    };
    return <form onSubmit={formik.handleSubmit}>{renderFormArea()}</form>;
};

export default SysStroreFilterForm;
